(function(){
 'use strict';
 function init(scope){
  scope.querySelectorAll('[data-mn-cart-page]').forEach(function(root){
   if(root.dataset.cartReady)return;
   var form=root.querySelector('form'),update=root.querySelector('[data-mn-update]');
   if(!form||!update)return;
   root.dataset.cartReady='true';
   root.querySelectorAll('[data-mn-qty]').forEach(function(button){button.hidden=false;});
   root.addEventListener('click',function(event){
    var button=event.target.closest('[data-mn-qty]');
    if(!button||!root.contains(button))return;
    var input=button.parentElement.querySelector('input'),current=Number(input.value),step=Number(input.step)||1,minimum=Number(input.dataset.minimum)||1;
    if(!Number.isInteger(current)||current<0){input.reportValidity();return;}
    var next=button.dataset.mnQty==='plus'?Math.max(minimum,current+step):Math.max(0,current-step);
    if(next<minimum)next=0;
    if(input.max!==''&&next>Number(input.max))return;
    input.value=String(next);
    if(form.reportValidity())form.requestSubmit(update);
   });
   form.addEventListener('submit',function(){root.setAttribute('aria-busy','true');});
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
 document.addEventListener('shopify:section:load',function(event){init(event.target);});
})();
